import { IColumn } from '@fluentui/react';
import { AllowEditAfterApprovalColumnHeader } from './ActivityColumnHeader';

export const ACTIVITY_TABLE_COLUMNS: IColumn[] = [
    { key: 'name', name: 'Name', fieldName: 'name', isRowHeader: true, minWidth: 240, maxWidth: 240, isResizable: true },
    { key: 'rate', name: 'Rate', fieldName: 'rate', minWidth: 120, maxWidth: 120, isResizable: true },
    { key: 'rateCurrencyCode', name: 'Currency', fieldName: 'rateCurrencyCode', minWidth: 120, maxWidth: 120, isResizable: true },
    {
        key: 'allowEditAfterApproval',
        name: 'Allow Edit After Approval',
        fieldName: 'allowEditAfterApproval',
        minWidth: 180,
        maxWidth: 180,
        isResizable: true,
        onRenderHeader: () => AllowEditAfterApprovalColumnHeader({}),
    },
    { key: 'actions', name: '', fieldName: 'actions', minWidth: 80, maxWidth: 80, isResizable: false },
];

export const TABLE_STYLES = {
    root: { maxWidth: 800, margin: '0 auto' },
    headerWrapper: {
        '.ms-DetailsHeader-cellName': { flex: '1 1 auto' },
    },
};
